<div class="re-flex re-flex-row re-items-center re-justify-center re-bg-white bdo-space--bottom re-h-150">
     <svg-icon class="re-shrink-0 re-w-20 re-h-20 re-ml-20 re-mr-15 re-leading-3" src="assets/icons/system_icons/alert.svg"></svg-icon>
     <span class="re-mr-20">{{ text }}</span>
</div>
